export default "__VITE_ASSET__CkSIMT1g__"